import type { TravelMode } from '../services/navigation';
import type { Settings } from '../stores/settingsStore';

export type PreferredTravelMode = Settings['preferredMode'];

export function preferredModeToTravelMode(mode: PreferredTravelMode): TravelMode {
  switch (mode) {
    case 'walking':
      return 'walking';
    case 'cycling':
      return 'cycling';
    case 'transit':
      return 'transit';
    case 'driving':
    default:
      return 'driving';
  }
}

interface ApplyPreferredModeOptions {
  /** When false, only update travel mode without refetching (e.g. on app load). */
  refetch?: boolean;
}

/** Sync directions travel mode from Settings → Navigation preferred mode. */
export async function applyPreferredTravelModeFromSettings(
  settings: Settings,
  options: ApplyPreferredModeOptions = {},
): Promise<void> {
  const { useDirectionsStore } = await import('../stores/directionsStore');
  const travelMode = preferredModeToTravelMode(settings.preferredMode);
  const state = useDirectionsStore.getState();
  if (state.travelMode === travelMode) return;

  const shouldRefetch =
    options.refetch !== false && Boolean(state.origin && state.destination);

  if (shouldRefetch) {
    state.setTravelMode(travelMode);
    return;
  }

  useDirectionsStore.setState({ travelMode });
}
